import React from "react";
// import clsx from "clsx";
import { UIStyleProps } from "./UIComponents";
import ImageView from "./Media/ImageView";
import { FileType } from "../../laco-common/base/models/IFile";
import "./UIUserAvatar.scss";

export type UIUserAvatarProps = {
	imageUrl?: string;
} & UIStyleProps;

const IMAGE_SIZE: number = 52;

export const UIUserAvatar: React.FC<UIUserAvatarProps> = (props: UIUserAvatarProps) => {
	const url: string = props.imageUrl;
	return (
		<div className="ui-user-avatar-container">
			<ImageView
				className="ui-user-avatar"
				viewWidth={IMAGE_SIZE}
				viewHeight={IMAGE_SIZE}
				image={{ filename: "", fileType: FileType.IMAGE, width: IMAGE_SIZE, height: IMAGE_SIZE, url }}
			/>
		</div>
	);
	// return <span className="ui-user-avatar" style={{ backgroundImage: `url(${url})` }} />;
};
